module.exports = ({ templateNode }) => {

  return {
    type: templateNode.type,
    text: templateNode.text,
  }

}



// WEBPACK FOOTER //
// ../node_modules/vqua/lib/virtual/createNode/createTextNode.js